var React = require('react');

function ReportInvalid (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M 12 1 C 10.7 1 9.5996875 1.84 9.1796875 3 L 5 3 C 3.9 3 3 3.9 3 5 L 3 19 C 3 20.1 3.9 21 5 21 L 19 21 C 20.1 21 21 20.1 21 19 L 21 5 C 21 3.9 20.1 3 19 3 L 14.820312 3 C 14.400313 1.84 13.3 1 12 1 z M 12 3 C 12.55 3 13 3.45 13 4 C 13 4.55 12.55 5 12 5 C 11.45 5 11 4.55 11 4 C 11 3.45 11.45 3 12 3 z M 8.3613281 7.3164062 L 11.894531 10.847656 L 15.398438 7.34375 L 16.892578 8.8378906 L 13.386719 12.34375 L 16.828125 15.783203 L 15.335938 17.277344 L 11.894531 13.835938 L 8.4257812 17.304688 L 6.9316406 15.810547 L 10.400391 12.341797 L 6.8671875 8.8105469 L 8.3613281 7.3164062 z "}));
}

ReportInvalid.defaultProps = {"viewBox":"0 0 24 24","height":"24","width":"24"};

module.exports = ReportInvalid;

ReportInvalid.default = ReportInvalid;
